import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import LoginInfo from '../login/LoginInfo';
import LogoImage from '../../../images/logo-image.png';
import Form from 'react-bootstrap/Form';
import Button from '../../../components/shared/buttons/button';
import ViewPassword from '../../../images/eye-icon.svg'
import { useLocation } from 'react-router-dom';
import { useResetPasswordMutation } from '../authApi';
import { showToast } from '../../../helpers/Utils';
import { useNavigate } from 'react-router-dom';
import HidePassword from '../../../images/eye-off.svg'
const ResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const token = searchParams.get('token');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [resetPassword, { isLoading }] = useResetPasswordMutation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!password) {
            showToast('Please add password', 'error');
            return;
        }
        if (password.length < 6) {
            showToast('New password must be at least 6 characters', 'error');
            return;
        }
        if (password !== confirmPassword) {
            showToast('Passwords do not match', 'error');
            return;
        }
        try {
            await resetPassword({
                token,
                newPassword: password
            });
            showToast('Password reset successful! Please login.', 'success');
            navigate('/login');
        } catch (err) {
            showToast('Failed to reset password', "error");
        }
    };

    return (
        <Row className='m-0'>
            <Col lg={6} className='p-0'>
                <div className='info_wrapper min-vh-100 d-flex justify-content-center align-items-center overflow-hidden position-relative'>
                    <LoginInfo />
                </div>
            </Col>
            <Col lg={6} className='p-0'>
                <div className='login_wrapper d-flex justify-content-center align-items-center min-vh-100'>
                    <div className='login_form'>
                        <div className='text-center'>
                            <img src={LogoImage} alt="logo" className='img-fluid' />
                        </div>
                        <h1 className='text-center'>Create Your Password</h1>
                        <p className='pt-3 text-center'>Enter your new password below to complete reset process</p>
                        {error && <div className='text-danger text-center mb-2'>{error}</div>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3 cmn_input">
                                <Form.Label>Create Password</Form.Label>
                                <div className="position-relative">
                                    <Form.Control
                                       type={showPassword ? "text" : "password"}
                                        placeholder="Enter new password"
                                        autoComplete="new-password"
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                    />
                                    <span className="view_pass">
                                        <img src={showPassword ?  ViewPassword : HidePassword} alt="eye"  onClick={() => setShowPassword(prev => !prev)} />
                                    </span>
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-4 cmn_input">
                                <Form.Label>Confirm Password</Form.Label>
                                <div className="position-relative">
                                    <Form.Control
                                       type={showConfirmPassword ? "text" : "password"}
                                                                              placeholder="Confirm password"
                                        autoComplete="new-password"
                                        value={confirmPassword}
                                        onChange={e => setConfirmPassword(e.target.value)}
                                    />
                                    <span className="view_pass">
                                        <img src={showConfirmPassword ? ViewPassword : HidePassword} alt="eye"    onClick={() => setShowConfirmPassword(prev => !prev)} />
                                    </span>
                                </div>
                            </Form.Group>
                            <Button label={isLoading ? 'Processing...' : 'Confirm'} size='medium' className="w-100" type="submit" disabled={isLoading} />
                        </Form>
                    </div>
                </div>
            </Col>

        </Row>
    )
}

export default ResetPassword